<div class="content-loaf">
  <div class="col-12">
    <h2>広域災害ＩＣＴ</h2>
  </div>
  <hr />

  <div class="row">
    <div class="col-12 col-md-4 center-block">
      <button class="btn btn-primary btn-primary-gradient" onclick="window.open('https://www.emis.mhlw.go.jp/public/s/')">ＥＭＩＳ入力</button>
    </div>

    <div class="col-12 col-md-4 center-block">
      <button class="btn btn-primary btn-primary-gradient" routerLink="/clinicstatuslist">診療所の状況</button>
    </div>

    <div class="col-12 col-md-4 center-block">
      <button class="btn btn-primary btn-primary-gradient" onclick="window.open('https://www.jcbasimul.com/fmhatsukaichi')">ＦＭはつかいち</button>
    </div>
  </div>
 </div>

<div class="content-loaf">
  <div class="col-12">
    <h2>マニュアル</h2>
  </div>
  <hr />

  <div class="row">
    <div class="col-12 manual-item">
      <a href="../pdf/MembersOnly/disaster_medical_response_manual.pdf" target="_blank"><img src="../Images/MembersOnly/pdf_icon.jpg" class="img-responsive pdf-icon" alt="災害時医療救護活動マニュアル ver.1.3">災害時医療救護活動マニュアル ver.1.3</a>
    </div>
  </div>
  <div class="row">
    <div class="col-12 manual-item">
      <a href="../pdf/MembersOnly/disaster_medical_response_manual_appendix.pdf" target="_blank"><img src="../Images/MembersOnly/pdf_icon.jpg" class="img-responsive pdf-icon" alt="災害時医療救護活動マニュアル 資料編（様式集）ver.1.">災害時医療救護活動マニュアル 資料編（様式集）ver.1.3</a>
    </div>
  </div>
</div>

